/**
 * Copyright © 2026 Delicious AI, LLC
 */

import React from 'react'

type PageHeaderActionsContextValue = {
  setActions: React.Dispatch<React.SetStateAction<React.ReactNode>>
}

const PageHeaderActionsContext =
  React.createContext<PageHeaderActionsContextValue | null>(null)

export const PageHeaderActionsProvider = PageHeaderActionsContext.Provider

export const usePageHeaderActions = (actions: React.ReactNode) => {
  const context = React.useContext(PageHeaderActionsContext)

  React.useEffect(() => {
    if (!context) return
    context.setActions(actions)

    return () => {
      context.setActions(null)
    }
  }, [actions, context])
}
